import React, { useContext, useState } from 'react'
import { GlobalContext } from '../context/globalContext'

const TransactionsList = () => {
  const { state, dispatch } = useContext(GlobalContext)
  const { transactions } = state

  const [selectedMonth, setSelectedMonth] = useState('')

  const filtered = selectedMonth
    ? transactions.filter((t) => {
        const month = new Date(t.date).getMonth()
        return month === parseInt(selectedMonth)
      })
    : transactions

  const del = (id) => {
    dispatch({ type: 'DELETE', payload: id })
  }
  return (
    <div>
      <h3>History</h3>

      <select
        value={selectedMonth}
        onChange={(e) => setSelectedMonth(e.target.value)}
      >
        <option value="">All</option>
        {Array.from({ length: 12 }, (_, i) => (
          <option key={i} value={i}>
            {new Date(2025, i).toLocaleString('en', { month: 'long' })}
          </option>
        ))}
      </select>

      <ul>
        {filtered.length === 0 ? (
          <p>Haven't any transactions</p>
        ) : (
          filtered.map((t) => (
            <li key={t.id}>
              {t.text} <span>{t.amount}$</span>
              <button onClick={() => del(t.id)}>Delete</button>
            </li>
          ))
        )}
      </ul>
    </div>
  )
}

export default TransactionsList
